export const marModalConfig: object = {
  cardName: "administrationEntry",
  access: "write",
  inputs: {
    medDetails: {
      type: "html",
    },
    isAdministered: {
      label: false,
      type: "radio",
      sortOrder: 1,
      componentId: "isAdministered",
      options: ["administered", "notAdministered"],
    },
    dosage: {
      type: "text",
      sortOrder: 3,
      componentId: "notesCategories",
      rules: {
        maxLength: 100,
        required: true,
      },
    },
    notes: {
      type: "textarea",
      sortOrder: 4,
      componentId: "notesDescription",
      rules: {
        rows: 5,
        maxLength: 500,
        required: true,
      },
    },
    verification: {
      label: false,
      type: "checkbox",
      sortOrder: 5,
      componentId: "verification",
      rules: {
        required: true,
      },
      options: ["electronicallyVerification"],
    },
    signature: {
      label: "electronicallySignedBy",
      type: "text",
      sortOrder: 6,
      componentId: "signature",
      rules: {
        required: true,
        mustEqual: "test",
        autocorrect: "off",
        autocomplete: "off",
      },
    },
    name: {
      type: "paragraph",
      innerHTML: "",
    },
  },
  layout: [
    {
      rows: [
        { id: "medDetails" },
        { id: "isAdministered" },
        { id: "dosage" },
        { id: "notes" },
        { id: "verification" },
        { id: "signature" },
        { id: "name" },
      ],
    },
  ],
  dependencies: [
    {
      id: "isAdministered",
      values: ["administered"],
      type: "enable",
      fields: ["dosage"],
    },
    {
      id: "verification",
      values: ["electronicallyVerification"],
      type: "enable",
      fields: ["signature"],
    },
    {
      id: "verification",
      values: [],
      type: "clear",
      fields: ["signature"],
    },
  ],
};



// WEBPACK FOOTER //
// ./src/configs/mar-modal-config.ts